import { ref } from 'vue'

import loadScript from '@/utils/loadScript'

interface LiveChatWindow {
  __lc: {
    license: number
    asyncInit?: boolean
  }
  LiveChatWidget: {
    _q: any[]
    _h: any | null
    _v: string
    on: (...args: any[]) => void
    once: (...args: any[]) => void
    off: (...args: any[]) => void
    get: (...args: any[]) => any
    call: (...args: any[]) => void
    init: () => void
  }
}

declare global {
  interface Window extends LiveChatWindow {}
}

const isLiveChatLoaded = ref(false)

const initializeLiveChat = async () => {
  if (isLiveChatLoaded.value) return

  window.__lc = window.__lc || {}
  window.__lc.license = 11293122

  window.LiveChatWidget = window.LiveChatWidget || {
    _q: [] as any[],
    _h: null,
    _v: '2.0',
    on(...args: any[]) {
      this._q.push(['on', ...args])
    },
    once(...args: any[]) {
      this._q.push(['once', ...args])
    },
    off(...args: any[]) {
      this._q.push(['off', ...args])
    },
    get(...args: any[]) {
      if (!this._h) throw new Error("[LiveChatWidget] You can't use getters before load.")
      return this._q.push(['get', ...args])
    },
    call(...args: any[]) {
      this._q.push(['call', ...args])
    },
    init() {
      loadScript('https://cdn.livechatinc.com/tracking.js')
        .then(() => {
          isLiveChatLoaded.value = true
        })
        .catch(() => {
          console.error('Failed to load LiveChat script.')
        })
    }
  }

  if (!window.__lc.asyncInit) {
    window.LiveChatWidget.init()
    window.__lc.asyncInit = true
  }
}

export default function useLiveChat() {
  return {
    initializeLiveChat,
    isLiveChatLoaded
  }
}
